// components/handleResetPassword.js
import { baseBackendURL } from "../helpers/baseUrl";

export const handleResetPassword = async (
  e,
  { email, captchaToken, setError, setSuccessMessage }
) => {
  e.preventDefault();
  setError("");
  setSuccessMessage("");
  try {
    const response = await fetch(`${baseBackendURL}/reset_password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email,
        captchaToken,
      }),
      credentials: "include",
    });
    const data = await response.json();
    if (data.success) {
      setSuccessMessage("Please check your email for a password reset link.");
    } else {
      setError(data.message || "Password reset failed");
    }
  } catch (error) {
    console.error("Error resetting password:", error);
    setError("Unable to reach server. Please try again later.");
  }
};
